import __request__ from "routing/request";
export function single(limit, offset) {
  return __request__("GET", "/system/indexer/failures", null, { "limit": limit, "offset": offset }, {
    "Accept": ["application/json"]
  });
}
export function count(since) {
  return __request__("GET", "/system/indexer/failures/count", null, { "since": since }, {
    "Accept": ["application/json"]
  });
}
